import { useEffect, useState } from "react";
import StepComplete from "../../../components/common/stepComplete/StepComplete";
import { useDispatch } from "react-redux";
import { setIsComplete } from "@src/@slice/recommendHallSlice";

import { HOSTNAME, isExternalUrl, isWebview } from "@src/utils";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";
import { closeWebview } from "@src/utils/route";
import StopRecommend from "./_component/StopRecommend";
import { sendRecommendHallChat } from "@src/api/recommend/recommend";
import HoneymoonSection from "@src/components/common/honeymoonSection/HoneymoonSection";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";

const Complete = () => {
  const dispatch = useDispatch();
  const { hallData } = useRecommendHall();
  const [showStopModal, setShowStopModal] = useState(false);

  const formatWeddingMonth = (yearMonths: string[]): string => {
    if (!yearMonths || yearMonths.length === 0) return "26년 9월";
    const firstMonth = yearMonths[0];

    const yearMatch = firstMonth.match(/(\d{4})년/);
    const monthMatch = firstMonth.match(/(\d{1,2})월/);

    if (yearMatch && monthMatch) {
      const year = yearMatch[1];
      const month = monthMatch[1];
      const shortYear = year.slice(-2);
      const monthNum = parseInt(month, 10);
      return `${shortYear}년 ${monthNum}월`;
    }

    const [year, month] = firstMonth.split("-");
    if (year && month) {
      const shortYear = year.slice(-2);
      const monthNum = parseInt(month, 10);
      if (!isNaN(monthNum)) {
        return `${shortYear}년 ${monthNum}월`;
      }
    }

    return "26년 9월";
  };

  const honeymoonTitle = formatWeddingMonth(hallData.hopeWedding.yearMonths);

  useEffect(() => {
    const handleSendChat = async () => {
      try {
        const res = await sendRecommendHallChat();
        if (!res) {
          return;
        }
        if (res.status === 200) {
          dispatch(setIsComplete({ bool: true }));
        }
      } catch (error) {
        console.error("sendRecommendHallChat: 에러 발생", error);
      }
    };

    handleSendChat();
  }, [dispatch]);

  const handleButtonClick = () => {
    window.location.href = isExternalUrl(`${HOSTNAME}/mypage/chat`);
  };

  return (
    <div className="recommend-hall-page recommend-hall-complete">
      <CustomHeader goBack={closeWebview} close={closeWebview} />
      {/* <StopRecommend showStopModal={showStopModal} setShowStopModal={setShowStopModal} /> */}
      <div className="recommend-hall-page-body">
        <div className="recommend-hall-complete-icon">
          <i className="icon icon-22 icon-check-white" />
        </div>
        <StepComplete
          title={`신청이 완료되었습니다.`}
          text={`희망 조건에 딱 맞는 웨딩홀 추천 리스트를
          알림톡과 웨딩북 채팅창으로 곧 보내드릴게요.`}
        />

        <p className="recommend-hall-complete-sub">*더 정밀한 추천을 위해 담당자가 해피콜을 드릴 수 있어요.</p>

        <HoneymoonSection
          title={`${honeymoonTitle} 허니문 추천`}
          description="웨딩홀 예약 커플의 75%가 벌써 신혼여행을 준비하고 있어요."
        />
      </div>
      <div className="recommend-hall-page-footer">
        <button className="btn btn-full btn-red500 btn-giant" onClick={handleButtonClick}>
          신청 내역 보기
        </button>
      </div>
    </div>
  );
};

export default Complete;
